"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "components", {
    enumerable: true,
    get: function() {
        return components;
    }
});
var _Accordion = require("./Accordion");
var _Alert = require("./Alert");
var _Autocomplete = require("./Autocomplete");
var _AutocompleteMultiSelect = require("./AutocompleteMultiSelect");
var _Avatar = require("./Avatar");
var _Badge = require("./Badge");
var _Breadcrumb = require("./Breadcrumb");
var _Button = require("./Button");
var _ButtonIcon = require("./ButtonIcon");
var _Card = require("./Card");
var _Checkbox = require("./Checkbox");
var _CloseButton = require("./CloseButton");
var _Divider = require("./Divider");
var _Dropdown = require("./Dropdown");
var _Icon = require("./Icon");
var _InlineAlert = require("./InlineAlert");
var _Input = require("./Input");
var _Link = require("./Link");
var _LinkIcon = require("./LinkIcon");
var _Modal = require("./Modal");
var _NumberInput = require("./NumberInput");
var _PinInput = require("./PinInput");
var _ProgressBar = require("./ProgressBar");
var _ProgressCircular = require("./ProgressCircular");
var _Radio = require("./Radio");
var _SegmentedButton = require("./SegmentedButton");
var _Select = require("./Select");
var _Skeleton = require("./Skeleton");
var _Slider = require("./Slider");
var _Spinner = require("./Spinner");
var _Stepper = require("./Stepper");
var _Switch = require("./Switch");
var _Symbols = require("./Symbols");
var _Tabs = require("./Tabs");
var _Tag = require("./Tag");
var _Text = require("./Text");
var _Textarea = require("./Textarea");
var _TextPairing = require("./TextPairing");
var _Tooltip = require("./Tooltip");
var components = {
    Accordion: _Accordion.Accordion,
    Alert: _Alert.Alert,
    Autocomplete: _Autocomplete.Autocomplete,
    AutocompleteMultiSelect: _AutocompleteMultiSelect.AutocompleteMultiSelect,
    Avatar: _Avatar.Avatar,
    Badge: _Badge.Badge,
    Breadcrumb: _Breadcrumb.Breadcrumb,
    Button: _Button.Button,
    ButtonIcon: _ButtonIcon.ButtonIcon,
    Card: _Card.Card,
    Checkbox: _Checkbox.Checkbox,
    CloseButton: _CloseButton.CloseButton,
    Divider: _Divider.Divider,
    Icon: _Icon.Icon,
    IconButton: _ButtonIcon.ButtonIcon,
    InlineAlert: _InlineAlert.InlineAlert,
    Input: _Input.Input,
    Kbd: _Symbols.Symbols,
    Link: _Link.Link,
    LinkIcon: _LinkIcon.LinkIcon,
    Menu: _Dropdown.Dropdown,
    Modal: _Modal.Modal,
    NumberInput: _NumberInput.NumberInput,
    PinInput: _PinInput.PinInput,
    Progress: _ProgressBar.ProgressBar,
    ProgressCircular: _ProgressCircular.ProgressCircular,
    Radio: _Radio.Radio,
    SegmentedButton: _SegmentedButton.SegmentedButton,
    Select: _Select.Select,
    Skeleton: _Skeleton.Skeleton,
    Slider: _Slider.Slider,
    Spinner: _Spinner.Spinner,
    Stepper: _Stepper.Stepper,
    Switch: _Switch.Switch,
    Tabs: _Tabs.Tabs,
    Tag: _Tag.Tag,
    Text: _Text.Text,
    Textarea: _Textarea.Textarea,
    TextPairing: _TextPairing.TextPairing,
    Tooltip: _Tooltip.Tooltip
};
